import { HotelCardReservationInfoPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-reservation-info/hotel-card-reservation-info.types";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { FC, memo } from "react";

const Component: FC<HotelCardReservationInfoPropertiesType> = (properties) => {
  const router = useCompatRouter();
  const { date_from, date_to } = router.query;
  const {
    nightCount,
    size = "responsive",
    roomTitle,
    isLanding,
    isHotelDomHomePage
  } = properties;

  const appName = process.env.NEXT_PUBLIC_APP_NAME || "";

  const hasDateAndPassengers = Boolean(
    date_from &&
      date_to &&
      router?.query?.["room_capacity"] &&
      Number(router?.query?.["room_capacity"]) > 0
  );

  const shouldShowFromPerNight =
    appName === "villa" && Boolean(hasDateAndPassengers);

  return (
    <div
      className={`flex flex-col items-start justify-end ${
        isLanding ? "w-1/2" : ""
      } ${size === "small" ? "" : "lg:items-center"}`}
    >
      {roomTitle &&
        size !== "xSmall" &&
        (["hotel-domestic", "tour"].includes(appName) ||
          isHotelDomHomePage) && (
          <div
            className={`flex ${
              size === "small"
                ? isLanding
                  ? "max-w-full"
                  : "max-w-[145px]"
                : "max-w-[175px]"
            } items-center gap-1 pb-2 md:py-2 lg:justify-center`}
          >
            <span
              className="text-caption text-on-surface-high-emphasis truncate"
              data-testid="hotel_card_room_title"
            >
              {numberConvert(roomTitle, {
                numberOnly: false,
                locale: router.locale
              })}
            </span>
          </div>
        )}
      {size === "small" ? (
        <div className="flex flex-col items-start gap-1">
          {shouldShowFromPerNight ? (
            <span className="text-on-surface-medium-emphasis text-caption">
              {` مجموع ${numberConvert(router?.query?.["room_capacity"] || 1, {
                locale: router?.locale
              })} نفر و ${numberConvert(nightCount, {
                locale: router?.locale
              })} شب`}
            </span>
          ) : (
            <span className="text-on-surface-medium-emphasis text-caption">
              قیمت از شبی
            </span>
          )}
        </div>
      ) : nightCount ? (
        <div className="text-body-2 text-on-surface-high-emphasis flex items-center justify-start gap-1 font-medium lg:justify-center">
          {`${numberConvert(nightCount, { locale: router.locale })} شب`}
        </div>
      ) : null}
    </div>
  );
};

export const HotelCardReservationInfo = memo(Component, deepCompare);
